import { render, staticRenderFns } from "./MyKennelRegistrationRequestList.vue?vue&type=template&id=56a5fc3b"
import script from "./MyKennelRegistrationRequestList.vue?vue&type=script&lang=ts"
export * from "./MyKennelRegistrationRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports